"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HpError = exports.HpDataSerializationError = void 0;
exports.ensureAllErrorsAreLogged = ensureAllErrorsAreLogged;
exports.errorToJsonObject = errorToJsonObject;
exports.errorToString = errorToString;
var _lodash = require("@avantia/lodash");
var _logger = require("./logger");
var _serializingUtilities = require("./serializingUtilities");
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const allErrors = []; // this allows us to ensure that all errors are logged.

let checkThatAllErrorsAreLogged = false;
function ensureAllErrorsAreLogged(ensure) {
  checkThatAllErrorsAreLogged = !!ensure;
}
class HpError extends Error {
  constructor(message, timeTaken) {
    // The super class doesn't have a message provided and this is intentional.
    // A new message getter is implemented in this class.
    super();
    _defineProperty(this, "name", 'HpError');
    _defineProperty(this, "messages", []);
    _defineProperty(this, "errorCode", void 0);
    _defineProperty(this, "isLogged", false);
    _defineProperty(this, "timeTaken", void 0);
    const {
      messages,
      name,
      stack
    } = messageUnknownToData(message);
    messages.forEach(m => this.addMessage(m));
    if (name) {
      this.name = (name.startsWith('Hp') ? '' : 'Hp') + name;
    }
    if (stack) {
      this.stack = stack;
    }
    if (checkThatAllErrorsAreLogged) {
      allErrors.push(this);
    }
    if (timeTaken) {
      this.timeTaken = timeTaken;
    }
  }

  /**
   * An easy way to determine if it's an HpError or not.
   */
  get isHpError() {
    return true;
  }
  get message() {
    return this.messages[0] || this.name;
  }
  addMessage(message) {
    this.messages.unshift(message);
  }
  toJson(options) {
    const {
      formatted = false,
      stackTrace = true
    } = options || {};
    return errorToString(this, {
      formatted,
      stackTrace
    });
  }
  toString() {
    return this.toJson();
  }
}
exports.HpError = HpError;
class HpDataSerializationError extends HpError {
  constructor(message, timeTaken) {
    super(message, timeTaken);
    _defineProperty(this, "info", void 0);
    _defineProperty(this, "invalidType", void 0);
  }
}
exports.HpDataSerializationError = HpDataSerializationError;
function errorToJsonObject(error, options) {
  const {
    stackTrace
  } = options;
  const data = JSON.parse(JSON.stringify(error));
  const {
    messages
  } = data;
  delete data.isLogged;
  if (messages && messages.length >= 1) {
    data.message = messages[0];
    delete data.messages; // it needs to go after message
    if (messages.length > 1) {
      data.messages = messages.slice(1);
    } else {
      delete data.messages;
    }
  }
  if (stackTrace && error.stack) {
    // for some reason it doesn't get serialized.
    data.stack = error.stack;
  }

  // Ensure the ordering of properties is consistent.
  const final = {
    name: data.name,
    message: data.message
  };
  _lodash.lodash.keys(data).sort().forEach(key => {
    if (key === 'name' || key === 'message') {
      return;
    }
    final[key] = data[key];
  });
  return final;
}
function errorToString(error, options) {
  const {
    formatted,
    stackTrace
  } = options;
  const final = errorToJsonObject(error, {
    stackTrace
  });
  return JSON.stringify(final, null, formatted ? 2 : undefined);
}
function messageUnknownToData(message) {
  const messages = [];
  const res = {
    messages
  };
  if (!message) {
    messages.unshift('No message was provided.');
  } else if (typeof message === 'string') {
    messages.unshift(message);
  } else if (message.isHpError) {
    const {
      messages,
      stack,
      name
    } = message;
    if (name) {
      res.name = name;
    }
    messages.unshift(...messages);
    if (stack) {
      res.stack = stack;
    }
  } else if ((0, _logger.isErrorType)(message)) {
    const {
      message: msgText,
      stack,
      name
    } = message;
    if (name) {
      res.name = name;
    }
    messages.unshift(msgText);
    if (stack) {
      res.stack = stack;
    }
  } else {
    const {
      error,
      result
    } = (0, _serializingUtilities.ensureDataIsSerializable)(message);
    if (error) {
      messages.unshift(error.message);
      messages.unshift(`The message could not be serialised.`);
    } else {
      messages.unshift('Details: ' + JSON.stringify(result));
    }
  }
  return res;
}

// So we can manipulate the bits we need to.